import React, { useState } from 'react';
import CategoryBadge from './CategoryBadge';
import SeverityBadge from './SeverityBadge';
import { useTheme, ACCENT } from '../contexts/ThemeContext';

function Section({ title, children, defaultOpen = false }) {
  const [open, setOpen] = useState(defaultOpen);
  const { t } = useTheme();
  if (!children) return null;
  return (
    <div style={{ paddingTop: '14px', marginTop: '14px', borderTop: `1px solid ${t.border}` }}>
      <button
        onClick={() => setOpen(!open)}
        style={{
          display: 'flex', alignItems: 'center', justifyContent: 'space-between',
          width: '100%', textAlign: 'left',
          background: 'none', border: 'none', cursor: 'pointer', padding: 0,
        }}
      >
        <span style={{
          fontSize: '10px', fontWeight: 700, color: t.textDim,
          letterSpacing: '0.1em', textTransform: 'uppercase',
        }}>
          {title}
        </span>
        <svg
          style={{
            width: '12px', height: '12px', color: t.textDim,
            transition: 'transform 0.2s',
            transform: open ? 'rotate(180deg)' : 'rotate(0deg)',
          }}
          fill="none" viewBox="0 0 24 24" stroke="currentColor"
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
        </svg>
      </button>
      {open && (
        <div style={{ marginTop: '10px', fontSize: '13px', color: t.textSecondary, lineHeight: 1.65 }}>
          {children}
        </div>
      )}
    </div>
  );
}

export default function AnalysisCard({ analysis, compact = false }) {
  const { t } = useTheme();

  if (!analysis || analysis.error) {
    return (
      <div className="card">
        <p style={{ color: '#F07070', fontSize: '12px', fontWeight: 600 }}>
          {analysis?.error || 'Analysis not available'}
        </p>
        {analysis?.raw && (
          <pre className="font-mono" style={{ fontSize: '10px', color: t.textDim, marginTop: '8px', whiteSpace: 'pre-wrap' }}>
            {analysis.raw}
          </pre>
        )}
      </div>
    );
  }

  return (
    <div className="card">
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '14px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
          <CategoryBadge category={analysis.category} />
          <SeverityBadge severity={analysis.severity} />
        </div>
        {analysis.flagForKB && (
          <span style={{
            display: 'inline-flex', alignItems: 'center',
            padding: '2px 8px', borderRadius: '6px',
            fontSize: '9px', fontWeight: 700,
            textTransform: 'uppercase', letterSpacing: '0.1em',
            background: 'rgba(249, 115, 22, 0.10)',
            color: '#F0923C',
            borderLeft: '2px solid #F0923C',
          }}>
            KB FLAG
          </span>
        )}
      </div>

      <p style={{ color: t.text, fontWeight: 600, fontSize: '14px', lineHeight: 1.55 }}>
        {analysis.summary}
      </p>

      {!compact && (
        <>
          <Section title="Assessment" defaultOpen>
            <p>{analysis.assessment}</p>
          </Section>

          <Section title="Customer Claim vs Reality">
            <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
              <div className="hud-bar-left">
                <span style={{
                  fontSize: '9px', fontWeight: 700, color: '#F07070',
                  display: 'block', marginBottom: '3px',
                  letterSpacing: '0.1em', textTransform: 'uppercase',
                }}>
                  Customer Expected
                </span>
                <p style={{ margin: 0 }}>{analysis.customerClaim}</p>
              </div>
              <div className="hud-bar-left">
                <span style={{
                  fontSize: '9px', fontWeight: 700, color: '#5B9BF7',
                  display: 'block', marginBottom: '3px',
                  letterSpacing: '0.1em', textTransform: 'uppercase',
                }}>
                  What Actually Happened
                </span>
                <p style={{ margin: 0 }}>{analysis.whatHappened}</p>
              </div>
            </div>
          </Section>

          <Section title="CARA Performance">
            <p>{analysis.caraPerformance}</p>
          </Section>

          <Section title="Recommendation">
            <p>{analysis.recommendation}</p>
          </Section>

          {analysis.kbNote && (
            <Section title="KB Update Note">
              <p style={{ color: '#F0923C' }}>{analysis.kbNote}</p>
            </Section>
          )}
        </>
      )}
    </div>
  );
}
